import { useEffect } from "react";

import { CbhFeatureFlag, useCbhFlag } from "../../FeatureFlags";
import { setCognitoApiTokenEnabled } from "./cognitoApiTokenState";

/**
 * Syncs the `2026-03-admin-enable-cognito-in-api-calls` LaunchDarkly flag
 * into module-level state so that non-React code (axios interceptors,
 * superagent helpers) can read the current value.
 *
 * Mount this hook once, high in the component tree (e.g. App layout).
 */
export function useSyncCognitoApiTokenFlag(): void {
  const isEnabled = useCbhFlag(CbhFeatureFlag.ADMIN_ENABLE_COGNITO_IN_API_CALLS, {
    defaultValue: false,
  });

  useEffect(() => {
    setCognitoApiTokenEnabled(isEnabled);
  }, [isEnabled]);
}
